import React from 'react';

export default function Home() {

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            backgroundColor: '#f5f5f5',
            padding: '20px',
            width: ' 100%'
        }}>
            <title>404 - Không tìm thấy trang</title>
            <meta name="description" content="Trang bạn đang tìm kiếm không tồn tại hoặc đã bị xóa." />
            <link rel="canonical" href="https://docviewer.top" />
            <h1>404 Not Found</h1>
        </div>
    );
}